import React from 'react';
import styled from "styled-components";
import {device} from "./Devices";
import {Splide, SplideSlide} from "@splidejs/react-splide";

import '@splidejs/react-splide/css';

function CodePortfolio({imageOne, imageTwo, imageThree, imageFour, imageFive, imageSix, title, description}) {

    return (

        <Code_Item>

            <Splide
                options={{
                    perPage: 1,
                    type: "loop",
                    width: 220,
                }}


            >
                <SplideSlide>
                    <img src={imageOne} alt="one"/>
                </SplideSlide>
                <SplideSlide>
                    <img src={imageTwo} alt="two"/>
                </SplideSlide>
                <SplideSlide>
                    <img src={imageThree} alt="three"/>
                </SplideSlide>
                <SplideSlide>
                    <img src={imageFour} alt="four"/>
                </SplideSlide>
                <SplideSlide>
                    <img src={imageFive} alt="five"/>
                </SplideSlide>
                <SplideSlide>
                    <img src={imageSix} alt="five"/>
                </SplideSlide>
            </Splide>

            <h1>{title}</h1>
            <p>{description}</p>
        </Code_Item>

    );
}

export default CodePortfolio;

const Code_Item = styled.div`

  width: 250px;
  height: 550px;
  padding: 20px;
  //border: 1px solid var(--blackShadow);
  background-color: var(--dimGrey);
  border-radius: 2px;
  box-shadow: 5px 5px 25px var(--dimGrey);
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 15px;
  
  @media ${device.tablet} {
    //margin: 0 60px;


  }

  img {
    width: 220px;
    height: 220px;
  }

  h1 {
    color: var(--mainTextColor);
    width: 220px;
    margin: 30px 0;
  }

  p {
    color: var(--blackShadow);
    width: 220px;
  }


`;